/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$x as $x,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ti as Ti,
  rec_api as api,
  rec_cO as cO,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function NuevaEtiqueta(e) {
  let t = (0, ReactCompiler.c)(20),
    { proyectoId: n, onCreada: r, onError: i } = e,
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(cO),
    l;
  t[0] !== s || t[1] !== a || t[2] !== r || t[3] !== i || t[4] !== n
    ? ((l = async function (e) {
        if ((e.preventDefault(), a.trim()))
          try {
            (await api(`/etiquetas`, {
              method: `POST`,
              body: JSON.stringify({
                proyectoId: n,
                nombre: a,
                color: s,
              }),
            }),
              o(``),
              r());
          } catch (e) {
            i(e.message);
          }
      }),
      (t[0] = s),
      (t[1] = a),
      (t[2] = r),
      (t[3] = i),
      (t[4] = n),
      (t[5] = l))
    : (l = t[5]);
  let u = l,
    f;
  t[6] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((f = (e) => o(e.target.value)), (t[6] = f))
    : (f = t[6]);
  let p;
  t[7] === a
    ? (p = t[8])
    : ((p = (
        <input
          className={Lo}
          placeholder={`Nombre de la etiqueta`}
          value={a}
          onChange={f}
        />
      )),
      (t[7] = a),
      (t[8] = p));
  let m;
  t[9] === s
    ? (m = t[10])
    : ((m = $x().map((e, t) => (
        <button
          key={e.fondo}
          type={`button`}
          onClick={() => c(e.fondo)}
          aria-label={`Color ${t + 1}`}
          aria-pressed={s === e.fondo}
          className={`h-7 w-7 rounded-full ${s === e.fondo ? `ring-2 ring-(--accent) ring-offset-1 ring-offset-(--bg)` : ``}`}
          style={{
            background: e.fondo,
          }}
        />
      ))),
      (t[9] = s),
      (t[10] = m));
  let h;
  t[11] === m
    ? (h = t[12])
    : ((h = <div className={`flex flex-wrap gap-1`} children={m} />),
      (t[11] = m),
      (t[12] = h));
  let _;
  t[13] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((_ = (
        <button
          type={`submit`}
          className={`${zo} ml-auto`}
          children={[<Ti className={`mr-1 inline h-3.5 w-3.5`} />, `Agregar`]}
        />
      )),
      (t[13] = _))
    : (_ = t[13]);
  let v;
  t[14] === h
    ? (v = t[15])
    : ((v = <div className={`flex items-center gap-2`} children={[h, _]} />),
      (t[14] = h),
      (t[15] = v));
  let y;
  return (
    t[16] !== u || t[17] !== p || t[18] !== v
      ? ((y = (
          <form
            onSubmit={u}
            className={`flex flex-col gap-2`}
            children={[p, v]}
          />
        )),
        (t[16] = u),
        (t[17] = p),
        (t[18] = v),
        (t[19] = y))
      : (y = t[19]),
    y
  );
}
